<template>
  <div v-if="content">
    <p class="title t-h5" v-text="t('footer.contact')" />
    <div class="t-p-m-160" v-html="nbsp(content)" />
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()

defineProps<{ content: string }>()
</script>

<style lang="scss" scoped></style>
